import { render } from "./JournalImages.vue?vue&type=template&id=fabed2d6"
import script from "./JournalImages.vue?vue&type=script&lang=js"
export * from "./JournalImages.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__